import { Injectable, inject, signal } from '@angular/core';
import { UserProfileStore } from '../../store/user-profile.store';
import { Feature } from '../../security/feature-permissions';
import { PermissionAdminService, PermissionWithRolesDto } from '../componentsServices/permission-admin.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private userProfileStore = inject(UserProfileStore);
  private adminSvc = inject(PermissionAdminService);

  private loaded = false; 
  private loadedSig = signal(false);
  private map: Map<string, number[]> = new Map();
  // Alias mapping from DB descriptions to Feature keys
  private static readonly ALIAS: Record<string, Feature> = {
    'model predictions tab': 'modelPredictions:view',
    'model accuracy tab': 'modelAccuracy:view',
    'trading strategy tab': 'tradingStrategy:view',
    'model definitions tab': 'modelDefinitions:view',
    'user enrollment': 'settings:users',
  'permissions settings': 'settings:permissions',
    'edit chevron cases': 'modelPredictions:editChevronCases',
     'give feedback': 'feedback:give',
    };

  constructor() {
    // Lazy-load mappings from API; descriptions must match Feature keys
    try {
      this.adminSvc.getPermissionsWithRoles().subscribe((rows: PermissionWithRolesDto[]) => {
        const m = new Map<string, number[]>();
        for (const r of (rows || [])) {
          const desc = String(r.description || '').trim();
          const norm = desc.toLowerCase();
          const key = PermissionService.ALIAS[norm] ?? norm; 
          m.set(key, r.roleIds || []);
        }
  this.map = m;
  this.loaded = true;
  this.loadedSig.set(true); 
      });
    } catch {}
  }

  // Returns true if the user's roleId is allowed for the feature
  can(feature: Feature): boolean {
  const _reactiveLoaded = this.loadedSig();
  const profile = this.userProfileStore.userProfile();
    const roleId = (profile?.roleId ?? null) as number | null;
    if (roleId == null) return false;
  if (!this.loaded) return false; 
  const dynamic = this.map.get(feature) || [];
  return dynamic.includes(roleId);
  }

  // Utility to check any of multiple features
  any(features: Feature[]): boolean {
    return features.some(f => this.can(f));
  }

  // Helper for settings gear: enabled if user has at least one settings feature
  canOpenSettings(): boolean {
    return this.any(['settings:users','settings:permissions']);
  }
}
